import { detectEnv } from "../../Components/Common/utils/detectEnv";

export function getHeaderContent() {
    const quotationCode = JSON.parse(localStorage.getItem('config') ?? '{}').quotation_code;

    let data = null;
    let is_bonogo = detectEnv().mirror === 'bonogo';
    if (is_bonogo) {
        try {
            data = require(`../hardCodedHeader/bonogo`).default;
        } catch (error) {
            console.error(error);
        }
    } else if (quotationCode) {
        try {
            data = require(`../hardCodedHeader/${quotationCode}`).default;
        } catch (error) {
            console.error(error);
        }
    }
    
    const defaultHeader = require(`../hardCodedHeader/beachcomber`).default;

    return data ?? {
        ...defaultHeader,
        logo: undefined,
        transparentLogo: undefined
    };
}